window.forceLandingPage = 'turns/turns.jade'
window.hideHome = true;